<template>
    <div class="data-list__item">
        <div class="data-list__item-title">{{ title }}</div>
        <div v-if="value" class="data-list__item-value">{{ value }}</div>
        <div v-else class="data-list__item-value--empty">(None)</div>
    </div>
</template>

<script>
export default {
    name: 'data-list-item',

    props: {
        title: {
            type: String,
            required: true,
        },

        value: {
            type: String,
            required: true,
        },
    },
};
</script>
